<template>
  <!-- ダウンロード形式選択 -->
  <ModalDialog
    pop-name="ダウンロード形式選択"
    dialog-width="700px"
    dialog-height="auto"
    :margin-class="show === true ? 'mbm-3' : 'mtp-3 mbm-3'"
    @close="closeModal"
  >
    <template #header> </template>

    <template #body>
      <div class="mtp-3">
        <div style="text-align: left">ダウンロード形式</div>
        <div style="text-align: left">
          <b-form-radio
            id="inlineRadio1"
            v-model="inlineRadio1"
            class="mtp-3"
            name="radio-size"
            value="option1"
            ><label for="inlineRadio1"
              >&nbsp;元ファイルの形式でダウンロード</label
            ></b-form-radio
          >
          <b-form-radio
            id="inlineRadio2"
            v-model="inlineRadio2"
            class="mtp-3"
            name="radio-size"
            value="option2"
          >
            <label for="inlineRadio2"
              >&nbsp;PDF（選択ファイル単位でダウンロード）</label
            >
          </b-form-radio>
        </div>
        <div class="d-flex mtp-3" style="justify-content: center">
          <ButtonMain
            button-name="ダウンロード"
            @click="download"
          ></ButtonMain>
        </div>

        <div v-if="showlog" class="row col-12 mtp-3">
          <table class="table table-hoer mbm-0">
            <thead>
              <tr class="th">
                <td>選択</td>
                <td>ファイルダウンロード状況</td>
                <td>有効期限</td>
              </tr>
            </thead>
            <tbody
              v-for="(item, index) in linkList"
              :key="index"
              class="downloadtbody"
            >
              <tr>
                <td align="center">
                  <input
                    v-if="item.date != 'ファイル処理中'"
                    id="check1"
                    type="checkbox"
                    class="form-check-input"
                    style="margin-right: 5px"
                    align="center"
                  />
                </td>
                <td>
                  <a v-if="item.links" class="link"
                    ><b>{{ item.urlcont }}</b></a
                  >
                  <span v-else>{{ item.urlcont }}</span>
                </td>
                <td>
                  {{ item.date }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>

    <template #footer>
      <div v-if="showlog" class="d-flex" style="justify-content: center">
        <ButtonDelete button-name="削除"></ButtonDelete>
      </div>
    </template>
  </ModalDialog>
</template>
<script>
export default {
  name: 'DownloadDialog',
  props: {
    links: Array,
    show: Boolean
  },
  data() {
    return {
      inlineRadio1: '',
      inlineRadio2: '',
      showlog: true,
      linkList: [
        {
          url: '',
          urlcont: 'ユーザID_YYYYMMDDHHmmSS',
          links: true,
          date: '令和4年10月13日 16:04:13'
        },
        {
          url: '',
          urlcont: 'ユーザID_YYYYMMDDHHmmSS',
          links: false,
          date: 'ファイル処理中'
        }
      ]
    }
  },
  mounted() {
    if (this.show === true) {
      this.showlog = false
    } else {
      this.showlog = true
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    download() {
      this.$emit('download')
    }
  }
}
</script>
<style scoped lang="scss">
.th {
  background-color: rgb(190, 229, 255);
  text-align: center;
}
</style>
